import { i18n } from '@b2ag/locale'
import { PAGE_TYPE } from '../page-types'

/* ------- MICROFRONT - LANDING ------- */

export const landingMainRoutes = [
  {
    path: '/help',
    name: 'contact',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'aide',
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'about',
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/partners',
    name: 'partners',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'partners',
        metaInfos: {
          title: i18n._('PAGE_NOS_PARTENAIRES_TITRE'),
          description: i18n._('PAGE_NOS_PARTENAIRES_DESCRIPTION'),
        },
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/brands',
    name: 'brands',
    component: () => import('@b2ag/micro-front-supplier/app'),
    props: () => {
      return {
        microFrontName: 'supplier',
        viewName: 'brands',
        metaInfos: {
          title: i18n._('LANDING_BRAND_TITLE'),
          description: i18n._('LANDING_BRAND_DESCRIPTION'),
        },
      }
    },
  },
  {
    path: '/shipping-methods',
    name: 'delivery-modes',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'livraisons',
        metaInfos: {
          title: i18n._('LANDING_DELIVERY_METHODS_TITLE'),
          description: i18n._('LANDING_DELIVERY_METHODS_DESCRIPTION'),
        },
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/payment-methods',
    name: 'payment-modes',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'paiements',
        metaInfos: {
          title: i18n._('LANDING_PAYMENT_METHODS_TITLE'),
          description: i18n._('LANDING_PAYMENT_METHODS_DESCRIPTION'),
        },
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.CONTACT_FAQ,
    },
  },
  {
    path: '/pages/partners',
    name: 'landing-page-partner',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'partner',
        metaInfos: {
          title: i18n._('LANDING_PARTNER_TITLE'),
          description: i18n._('LANDING_PARTNER_DESCRIPTION'),
        },
      }
    },
  },
  {
    path: '/pages/suppliers',
    name: 'landing-page-provider',
    component: () => import('@b2ag/micro-front-landing/app'),
    props: () => {
      return {
        microFrontName: 'landing',
        viewName: 'provider',
        metaInfos: {
          title: i18n._('LANDING_PROVIDER_TITLE'),
          description: i18n._('LANDING_PROVIDER_DESCRIPTION'),
        },
      }
    },
  },
]
